import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['year', 'month', 'day'];
  static values = { year: Number, day: Number }

  connect() {
    this.generateYearOptions();

    if (this.hasYearValue && this.yearValue) {
      this.yearTarget.value = String(this.yearValue);
    }

    const monthVal = this.monthTarget && this.monthTarget.value;
    if (monthVal) {
      this.updateDayOptions();
      if (this.hasDayValue && this.dayValue) {
        this.dayTarget.value = String(this.dayValue);
      }
    } else if (this.hasDayValue && this.dayValue && this.dayTarget.options.length > 0) {
      this.dayTarget.value = String(this.dayValue);
    }
  }

  resetMonthAndDay() {
    this.monthTarget.selectedIndex = '';
    this.dayTarget.selectedIndex = '';
  }

  resetDay() {
    this.dayTarget.selectedIndex = '';
  }

  generateYearOptions() {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 65;
    const endYear = currentYear - 20;
    const yearOptions = [];

    for (let year = startYear; year <= endYear; year++) {
      yearOptions.push([`${year}年`, year]);
    }

    yearOptions.forEach(option => {
      const opt = document.createElement('option');
      opt.value = option[1];
      opt.textContent = option[0];
      this.yearTarget.appendChild(opt);
    });
  }

  updateDayOptions() {
    const year = parseInt(this.yearTarget.value, 10);
    const month = parseInt(this.monthTarget.value, 10);

    if (isNaN(year) || isNaN(month)) {
      return;
    }

    this.dayTarget.innerHTML = '';

    const daysInMonth = new Date(year, month, 0).getDate();

    this.dayTarget.appendChild(new Option('日', '', true, true));
    for (let day = 1; day <= daysInMonth; day++) {
      const opt = document.createElement('option');
      opt.value = day;
      opt.textContent = `${day}日`;
      this.dayTarget.appendChild(opt);
    }
  }
}
